import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '../../hooks/useBranding';

export const MinimumDurationBadge = () => {
  const { t } = useTranslation();
  const branding = useBranding();

  return (
    <div
      className={`${
        branding === 'hug' ? 'badge-blue' : ''
      } badge text-center text-wrap d-flex flex-column justify-content-center align-items-center`}
    >
      <p>{t('timelineSection.badgeDescription.part1')}</p>
      <p className="fs-3 fw-bold mb-2">{t('timelineSection.badgeDescription.part2')}</p>
      <span className="mb-1">{t('timelineSection.badgeDescription.part3')}</span>
      <span>{t('timelineSection.badgeDescription.part4')}</span>
    </div>
  );
};
